import React, { Component } from "react"
import "./Support.css"

class Support extends Component {
  state = { subject: '', message: '', submitted: false, error: false, messageError: false }

  submit = async (e) => {
    e.preventDefault()
    const { message } = this.state
    if (!message.trim()) {
      this.setState({ messageError: true })
      return
    }
    const { name, email } = this.props.user
    const { subject } = this.state
    const apiKey = localStorage.getItem('api_key')
    try {
      const resp = await fetch('/api/support/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-HNGR-API-KEY': apiKey,
        },
        body: JSON.stringify({ name, email, subject, message }),
      })
      if (!resp.ok) throw new Error()
      this.setState({ submitted: true })
    } catch {
      this.setState({ error: true })
    }
  }

  render() {
    if (!this.props.user) return null
    const { submitted, error, subject, message, messageError } = this.state
    if (submitted) {
      return (
        <div className="Support">
          <h1 className="m0">Support</h1>
          <div className="pv8 fs12 fw700 c222 inline-block w100">
            Message sent. We'll be in touch.
          </div>
        </div>
      )
    }
    return (
      <div className="Support">
        <h1 className="m0">Support</h1>
        <div className="pv8 fs12 fw700 c222 inline-block w100">
          Contact Captain Support
        </div>
        <form onSubmit={this.submit}>
          <div className="fs12 fw700 c222 mt16">Subject</div>
          <input
            className="mv16"
            type="text"
            value={subject}
            onChange={(e) => this.setState({ subject: e.target.value })}
          />
          <div className="fs12 fw700 c222">Message *</div>
          <textarea
            className="mv16"
            rows={8}
            value={message}
            onChange={(e) => this.setState({ message: e.target.value, messageError: false })}
          />
          <br />
          {messageError && (
            <div className="fs12 c222">Message is required to submit</div>
          )}
          {error && (
            <div className="fs12 c222">
              Something went wrong. Please try again or email support@gocaptain.com
            </div>
          )}
          <button className="button" type="submit">SUBMIT</button>
        </form>
      </div>
    )
  }
}

export default Support
